import React from "react";
import "./HomeDescriptionMobile.css";

export default function HomeDescriptionMobile() {
  return (
    <>
      <div className="HomeDescriptionMobile">
        <span className="homeDescriptionMobileText">
          横浜市の音楽教室／二俣川／
        </span>
        <span className="homeDescriptionMobileText">
          三ツ境／チェロ／声楽／
        </span>
        <span className="homeDescriptionMobileText">
          出張レッスン／出張演奏
        </span>
      </div>
    </>
  );
}
